import { useState } from 'react';
import { Icon } from '../Icon';
import './CollapsiblePanel.scss';

export const CollapsiblePanel = ({ 
    children, 
    className='',
    note = null,
    onNoteClick = () => {}
}) => {
    const [collapsed, setCollapsed] = useState(true);

    const handleToggle = () => {
        setCollapsed(c => !c);
    };

    const handleNoteClick = (e) => {
        onNoteClick();
        e.stopPropagation();
    };

    return (
        <div className={`CollapsiblePanel ${className}`}>
            <div className={`body ${collapsed ? 'collapsed' : ''}`}>
                { children }
            </div>
            <button
                onClick={handleToggle}
            >
                <Icon 
                    name={`angle-double-${collapsed ? 'down' : 'up'}`}
                    size='medium'
                />
                {note &&
                    <span
                        className='note'
                        onClick={handleNoteClick}
                    >
                        {note}
                    </span>
                }
            </button>
        </div>
    );
};